import { createFileRoute } from "@tanstack/react-router";
import { OperacionPwa } from "@/components/operacion-portal/OperacionPwa";
import { PortalPersonal } from "@/components/operacion-portal/PortalPersonal";
import { robotsMeta } from "@/lib/seo";

// El HTML de esta ruta NO contiene datos de la persona: es solo la carcasa de la
// app (por eso el service worker puede guardarla). Turnos y reportes llegan por
// server functions con la cookie de sesión, después de hidratar.
export const Route = createFileRoute("/operacion/")({
  head: () => ({
    meta: [{ title: "Mis turnos — Operación en Vivo" }, ...robotsMeta(false, false)],
  }),
  component: OperacionPage,
});

function OperacionPage() {
  return (
    <main className="min-h-screen bg-background">
      <OperacionPwa />
      <PortalPersonal />
    </main>
  );
}
